import React, { FunctionComponent } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { ISimpleTasks } from '../../../../../app/page/page-storage/meeting-tasks/meeting-tasks.types';
import { WidgetTasksList } from '../../../common/widgets/WidgetTasksList';
import { IActionItemsProps } from './types';

export const ActionItems: FunctionComponent<IActionItemsProps> = ({ userId, actionItems, adminIds, meetingId }) => {
  const userActionItems = actionItems.hasOwnProperty(Number(userId))
    ? ((actionItems[Number(userId)] as unknown) as ISimpleTasks)
    : { active: [], done: [] };
  const isAdmin = adminIds.includes(userId);
  return (
    <Droppable droppableId={userId} key={userId} isDropDisabled={true}>
      {(provided) => (
        <div {...provided.droppableProps} ref={provided.innerRef}>
          <WidgetTasksList
            activeIds={userActionItems.active}
            doneIds={userActionItems.done}
            type={'board'}
            isAdmin={isAdmin}
            userId={userId}
            meetingId={meetingId}
          />
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};
